module.exports = __webpack_public_path__ + "static/media/PizzaBase.e87ca321.png";